import * as Sentry from '@sentry/react'
import {
  extractFileExtension,
  reportSignedUrlOssUploadFailure,
  SignedUrlOssUploadError,
  summarizeSignedUploadUrl,
  type SignedUrlOssUploadContext,
} from './reportSignedUrlOssUploadFailure'

export async function uploadFileToSignedOssUrl(
  signedUrl: string,
  file: File | Blob,
  options: {
    contentType: string
    context: SignedUrlOssUploadContext
  }
): Promise<void> {
  const uploadUrlSummary = summarizeSignedUploadUrl(signedUrl)
  const fileMimeType = file instanceof File ? file.type : undefined
  const fileExtension = extractFileExtension(options.context.fileName)

  Sentry.addBreadcrumb({
    category: 'oss-upload',
    message: 'PUT signed URL',
    level: 'info',
    data: {
      feature: options.context.feature,
      fileName: options.context.fileName,
      fileSizeBytes: options.context.fileSizeBytes,
      uploadUrlHost: uploadUrlSummary.host,
    },
  })

  const uploadStartedAt = performance.now()

  try {
    const response = await fetch(signedUrl, {
      method: 'PUT',
      body: file,
      headers: { 'Content-Type': options.contentType },
    })
    if (!response.ok) {
      const text = await response.text()
      throw new SignedUrlOssUploadError(`Upload failed (${response.status})`, {
        httpStatus: response.status,
        responseBody: text || response.statusText,
      })
    }
  } catch (error) {
    reportSignedUrlOssUploadFailure({
      signedUrl,
      context: options.context,
      error,
      diagnostics: {
        uploadDurationMs: Math.round(performance.now() - uploadStartedAt),
        fileMimeType,
        fileExtension,
      },
    })
    throw error
  }
}
